import React, { useEffect, useRef, useState } from 'react';

import {
  Dropdown,
  DropdownButton,
  DropdownIcon,
  DropdownItem,
  DropdownMenu,
} from './PriorityDropdown.styles';

const PRIORITY_OPTIONS = [
  { id: 'high', label: 'High', color: '#dc2626' },
  { id: 'medium', label: 'Medium', color: '#f59e0b' },
  { id: 'low', label: 'Low', color: '#3b82f6' },
  { id: 'new', label: 'New', color: '#6366f1' },
];

const PriorityDropdown = ({ currentPriority, onPriorityChange, onClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const currentOption =
    PRIORITY_OPTIONS.find((opt) => opt.id === currentPriority?.toLowerCase()) ||
    PRIORITY_OPTIONS[3];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleToggle = (e) => {
    e.stopPropagation();
    if (onClick) onClick(e);
    setIsOpen(!isOpen);
  };

  const handleSelect = (priorityId, e) => {
    e.stopPropagation();
    onPriorityChange(priorityId);
    setIsOpen(false);
  };

  return (
    <Dropdown ref={dropdownRef}>
      <DropdownButton onClick={handleToggle} $color={currentOption?.color}>
        {currentOption?.label}
        <DropdownIcon $isOpen={isOpen}>▼</DropdownIcon>
      </DropdownButton>
      {isOpen && (
        <DropdownMenu>
          {PRIORITY_OPTIONS.map((option) => (
            <DropdownItem
              key={option.id}
              onClick={(e) => handleSelect(option.id, e)}
              $color={option.color}
              $isActive={option.id === currentPriority?.toLowerCase()}
            >
              {option.label}
            </DropdownItem>
          ))}
        </DropdownMenu>
      )}
    </Dropdown>
  );
};

export default PriorityDropdown;
